import React, { useEffect, useState } from "react";
import { Field, Form } from "react-final-form";
import { API_URL } from "../../config";
import { useNavigate } from "react-router";
import { User } from "../../models/User";

interface VerifyFormValues {
    document: File[];
    residence: File[];
}

export const Verify: React.FC = () => {

    const navigate = useNavigate();
    const [userData, setUserData] = useState<User | null>(null);
    const [errors, setErrors] = useState<string[]>([]);
    const [success, setSuccess] = useState<boolean>(false);
    // const [files, setFiles] = useState(new Map<string, File>());

    useEffect(() => {
        fetch(API_URL + "profile?token=" + localStorage.getItem("token"))
            .then((response) => response.json())
            .then((response: User) => {
                setUserData(response);

                if (response.is_verified) {
                    navigate("/profile");
                }

                $('[data-toggle="tooltip"]').tooltip();
            })
            .catch(() => {
                navigate("/");
            });
    }, [navigate]);

    const onSubmit = async (values: VerifyFormValues): Promise<void> => {
        const formData = new FormData();

        for (const key in values) {
            if (values.hasOwnProperty(key)) {
                formData.append(key, values[key][0]);
            }
        }

        fetch(API_URL + 'verification?token=' + localStorage.getItem("token"), {
            method: "POST",
            body: formData,
        }).then((response) => response.json()).then(() => {
            setErrors([]);
            setSuccess(true);
        });
    };

    return (
        <div className="wlc-bg1">
            <section className="welcome-page-area">
                <div className="container">
                    <div className="welcome-page">
                        <span className="wel-page-left-arrow">
                            <img src="https://marketplace.nfty.property/img/img/us-left.png" className="img-fluid" alt="" />
                        </span>

                        <div className="sign-in-popup-form">
                            {userData?.documents?.length && userData.documents.length > 0 && (
                                <div style={{ paddingBottom: '50px' }}>
                                    <h2 style={{ textAlign: 'center', paddingBottom: '20px' }}>Submitted documents</h2>
                                    <div>
                                        {userData.documents.map((document) => (
                                            <div key={document.id}>
                                                <strong>
                                                    <a
                                                        style={{ color: 'black' }}
                                                        target="_blank"
                                                        href={API_URL + 'downloadDocument/' + document.id + '?token=' + localStorage.getItem("token")}
                                                        rel="noreferrer"
                                                    >
                                                        {document.type.name}
                                                    </a>{" "}
                                                    -{" "}
                                                </strong>

                                                {document.status === 'review' && <span>In  review</span>}
                                                {document.status === 'accepted' && <span style={{ color: 'green' }}>Accepted</span>}
                                                {document.status === 'declined' && <span style={{ color: 'red' }}>Declined</span>}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                            <div className="popup-form-title">
                                <h2>Verification</h2>
                                <p style={{ textAlign: 'left' }}>
                                    It’s never been easier to trade some really nfty property.<br /><br />
                                    Just tell us who you are, and become a verified member. You’ll be leaping up that property ladder before you know it!<br />
                                </p>
                            </div>
                            {errors.length > 0 && (
                                <div className="alert alert-danger" role="alert">
                                    {errors.map((error) => (
                                        <span key={'error' + error}>{error}</span>
                                    ))}
                                </div>
                            )}
                            {success && (
                                <div className="alert alert-success" role="alert">
                                    Thank you for submitting the documents!
                                </div>
                            )}
                            <Form
                                validate={(values) => {
                                    const errors: Record<string, string> = {};
                                    return errors;
                                }}
                                onSubmit={onSubmit}
                                render={({ handleSubmit, form, submitting, pristine, values }) => (
                                    <form onSubmit={handleSubmit}>
                                        <Field name="document">
                                            {({ input: { value, onChange, ...input }, meta }) => (
                                                <div>
                                                    <div className="popup-sign-item">
                                                        <label htmlFor="document">
                                                            Photo I.D {meta.error && meta.touched && <span style={{ color: 'red' }}>{meta.error}</span>}
                                                        </label>
                                                        <input
                                                            {...input}
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="Passport, or drivers licence"
                                                            type="file"
                                                            className="form-value-color"
                                                            id="asif-pl"
                                                            onChange={({ target }) => onChange(target.files)}
                                                            placeholder=""
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </Field>

                                        <Field name="residence">
                                            {({ input: { value, onChange, ...input }, meta }) => (
                                                <div>
                                                    <div className="popup-sign-item">
                                                        <label htmlFor="residence">
                                                            Proof of Address {meta.error && meta.touched && <span style={{ color: 'red' }}>{meta.error}</span>}
                                                        </label>
                                                        <input
                                                            {...input}
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="Such as recent utility bill, or legal document addressed to you at your home address"
                                                            type="file"
                                                            className="form-value-color"
                                                            id="asif-pl"
                                                            placeholder=""
                                                            onChange={({ target }) => onChange(target.files)}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </Field>

                                        <div className="popup-sign-in-submite wcl-btn">
                                            <button type="submit">Submit</button>
                                        </div>
                                    </form>
                                )}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};